import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { DeleteActionValidationStatus } from "../sidebar-toolbar-types";

export function useDeleteActionTooltip(status: DeleteActionValidationStatus) {
    const translate = useIventisTranslate();

    switch (status) {
        case DeleteActionValidationStatus.InvalidSelectionAmount:
            return translate(Content.map11.map_delete_status.amount);
        case DeleteActionValidationStatus.InvalidPermissions:
            return translate(Content.map11.map_delete_status.permissions);
        case DeleteActionValidationStatus.InvalidTypeSelection:
            return translate(Content.map11.map_delete_status.type);
        case DeleteActionValidationStatus.MapLoading:
            return translate(Content.map11.map_delete_status.loading);
        case DeleteActionValidationStatus.Valid:
            return translate(Content.map11.map_delete_status.explain);
        default:
            throw new Error(`Status of ${status} not handled`);
    }
}
